module.exports = __webpack_public_path__ + "img/apiecobooster.e8607b25.jpg";